/** @noinline */
export const constRef = /*#__NOINLINE__*/ {};
/** @noinline */
export const constExoticDeps = [];
/** @noinline */
export const constDeps = constExoticDeps;
